import { store } from './store'

export const EnsureUserLoggedin = function (to, from, next) {
    if (!store.User) {
        alert("You must be logged in to access this page")
        next('/myaccount')
    }
    else next()
}

export const RetrieveAuthToken = async function (userEmail, userPW) {
    // Request AuthCookie
    const data = await CallApi("POST", "/login", {
        email: userEmail,
        password: userPW
    })
    
    if (data) {
        // Persist API Response to Store
        store.organization_types = (data.organization_types).sort((a,b) => a.id > b.id ? 1 : -1)
        store.interaction_types = (data.interaction_types).sort((a,b) => a.id > b.id ? 1 : -1)
        store.salesstages = (data.salesstages).sort((a,b) => a.id > b.id ? 1 : -1)
        store.User = data.user

        // Persist to Session Storage
        localStorage.setItem("user", JSON.stringify(data.user))
        localStorage.setItem("organization_types", JSON.stringify(data.organization_types));
        localStorage.setItem("interaction_types", JSON.stringify(data.interaction_types));
        localStorage.setItem("salesstages", JSON.stringify(data.salesstages));
    }
}

export const fileToB64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result.split(',')[1]);
    reader.onerror = error => reject(error);
})

/**
 * Validates if the provided MIME type is supported by JIMP.
 * @param {File} file - The uploaded file.
 * @returns {boolean} - True if the MIME type is supported, false otherwise.
 */
export const isJimpSupportedMimeType = function(file) {
  const supportedMimeTypes = [
    'image/png',
    'image/jpeg',
    'image/bmp',
    'image/tiff',
    'image/gif'
  ];
  const mimeType = file.type;
  return mimeType ? supportedMimeTypes.includes(mimeType.toLowerCase()) : false;
}

// Utility Functions
export const CallApi = async function (restMethod, endpoint, requestBody) {
    // Construct URL
    const protocol = (window.location.hostname == 'localhost' || window.location.hostname == '127.0.0.1') ? 'http://' : 'https://'
    const port = (window.location.hostname == 'localhost' || window.location.hostname == '127.0.0.1') ? ':3000' : '/api'
    const requestUrl = protocol + window.location.hostname + port + endpoint

    // Generate Headers for Our Fetch
    const fetchOptions = {
        method: restMethod,
        
        credentials: "include",
        headers: new Headers({
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        })
    }

    // Encode Data as FormData
    if ((requestBody) && (restMethod != "GET")) {
        fetchOptions.body = JSON.stringify(requestBody)
    }

    // Query Server for Data
    const payload = await (await fetch(requestUrl, fetchOptions)).json()

    // Return Appropriate Data
    if (payload.status != 'ok') {
        // Not Logged-In Message
        if (payload.messages[0] == "AssertionError [ERR_ASSERTION]: missing token") {          
            // Clear Cached User Object
            localStorage.removeItem("user");
            store.User = {}

            // Redirect to Login
            window.location = '/myaccount';
        // Other Errors
        } else {
            alert(payload.messages.join('\n'))
        }
    } else {
        return payload.result
    }
}

export default { CallApi, RetrieveAuthToken, EnsureUserLoggedin, fileToB64 }
